import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const setOperationalSmsConsent = {
  name: "setOperationalSmsConsent" as const,
  input: z.object({ consented: z.boolean() }),
  output: z.object({
    consented: z.boolean(),
    consentedAt: zExt.instant().nullable(),
  }),
};
